import { Component, Vue } from 'vue-property-decorator'
import { TagsViewModule } from '@/store/modules/tags-view'
import { createAnomalyOrder, getAnomalyStaticData, getAnomalyObjectName, getAnomalyObjectDetail, queryClass } from '@/api'
import moment from 'moment'
import urlBase from '@/utils/urlBase'

interface Anomaly {
  courseTypeId: number | null; // 项目异常类别
  subjectName: string; // 对象名称
  anomalyType: number | null; // 异常类型
  subjectId: number | null; // 异常对象
  subjectType: number | null; // 异常对象类型
  progress: string; // 沟通进度
  cause: string; // 异常原因
  imageList: Array<string>; // 沟通截图
  classId?: string; // 班级id
}

interface Project {
  id: string;
  name: string;
  typeStr: string;
  schoolBegins: string;
}

@Component({ name: 'abnormal-create-page' })
export default class AbnormalCreatePage extends Vue {
  private anomalyData: Anomaly = {
    courseTypeId: null,
    subjectName: '',
    anomalyType: null,
    subjectId: null,
    subjectType: null,
    progress: '',
    cause: '',
    classId: '',
    imageList: []
  }

  private objList = []
  private classType: any = null
  private projectData: any = {
    name: '',
    masterName: '',
    schoolBegins: '',
    directorName: '',
    TAName: '',
    typeStr: '',
    sources: '',
    consultingTeacher: ''
  }

  // TODO
  private uploadUrl = urlBase.eduBaseUrl + 'upload/anomaly/notice'
  // private uploadUrl = 'http://192.168.0.33:10069/upload/anomaly/notice'
  private anomalyType = [] // 异常类型 预警，退费，投诉
  private subjectType = [] // 异常主体类型
  private courseType = [] // 个人，导师
  private classList: any = [] // 班级列表
  created () {
    this.initPageData()
  }

  private async initPageData () {
    const { subjectTypes, courseTypes }: any = await getAnomalyStaticData({})
    this.subjectType = subjectTypes
    this.courseType = courseTypes
  }

  /**
   * [description] 删除沟通截图
   */
  private onDeleteImg (index: any) {
    this.anomalyData.imageList.splice(index, 1)
  }

  /**
   * [description] 异常提交
   */
  private async onSubmitClick () {
    const param: any = {
      courseTypeId: this.anomalyData.courseTypeId,
      anomalyType: Number(this.anomalyData.anomalyType),
      subjectType: this.anomalyData.subjectType,
      subjectId: this.anomalyData.subjectId,
      cause: this.anomalyData.cause,
      imageList: this.anomalyData.imageList,
      progress: this.anomalyData.progress
    }
    if (this.anomalyData.classId) { param.classId = this.anomalyData.classId }
    const { error }: any = await createAnomalyOrder(param)
    if (!error) {
      this.$message({ message: '操作成功', type: 'success' })
      TagsViewModule.delView(this.$route)
      this.$router.push({ path: '/approve/abnormal' })
    }
  }

  /**
   * [description] 上传沟通
   */
  private handleAbnormalSuccess (res: any) {
    this.anomalyData.imageList.push(res.data)
  }

  /**
   * [description] select进行了选择操作
   */
  private async onSelectChoose () {
    const obj: any = this.courseType.find((item: any) => item.id === this.anomalyData.courseTypeId)
    this.classType = obj.classType
    if (this.anomalyData.courseTypeId && this.anomalyData.subjectType) {
      const result: any = await getAnomalyObjectName({ subjectType: this.anomalyData.subjectType, courseType: this.anomalyData.courseTypeId, classType: this.classType })
      this.objList = result
    }
    this.anomalyData.subjectId = null
    this.resetClassData()
  }

  private async onObjectChoose (obj: any) {
    this.anomalyData.classId = ''
    const param: any = {}
    if (this.anomalyData.subjectType === 1) {
      // 学员个人
      param.studentId = this.anomalyData.subjectId
    } else if (this.anomalyData.subjectType === 2) {
      // 导师个人
      param.masterId = this.anomalyData.subjectId
    } else if (this.anomalyData.subjectType === 3) {
      // TA个人
      param.TAId = this.anomalyData.subjectId
    } else if (this.anomalyData.subjectType === 4) {
      // 项目小组
    }
    param.classType = this.classType
    param.courseType = this.anomalyData.courseTypeId
    const classList = await queryClass(param)
    this.classList = classList
    this.resetClassData()
    this.anomalyData.anomalyType = null
  }

  private async onObjSelectChoose () {
    if ((this.anomalyData.classId === '' && this.anomalyData.subjectType !== 4) || this.anomalyData.subjectId === null || this.anomalyData.anomalyType === null) return
    const param: any = { anomalyType: this.anomalyData.anomalyType, subjectType: String(this.anomalyData.subjectType), subjectId: this.anomalyData.subjectId }
    if (this.anomalyData.classId) {
      param.classId = this.anomalyData.classId
      let classData = this.classList.filter((item: any) => { return item.classId === param.classId })
      if (classData.length > 0) {
        classData = classData[0]
        param.courseTypeId = classData.courseTypeId
      }
    }
    const result: any = await getAnomalyObjectDetail(param)
    this.projectData = result === null ? this.projectData : result
    this.projectData.schoolBegins = this.projectData.schoolBegins ? moment(this.projectData.schoolBegins).format('YYYY/MM/DD') : '-'
  }

  // 重置
  private resetClassData () {
    this.projectData = {
      name: '',
      masterName: '',
      schoolBegins: '',
      directorName: '',
      TAName: '',
      typeStr: '',
      sources: '',
      consultingTeacher: ''
    }
  }

  private onSubjectTypeChoose () {
    this.anomalyData.subjectId = null
    this.anomalyData.anomalyType = null
    const result: any = this.subjectType.filter((item: any) => { return item.subjectType === this.anomalyData.subjectType })
    const anomalysList = result[0].anomalysList
    this.anomalyType = anomalysList
    this.onSelectChoose()
  }
}
